import { render, staticRenderFns } from "./ProjectProductivityGraph.vue?vue&type=template&id=64618d81"
import script from "./ProjectProductivityGraph.vue?vue&type=script&lang=js"
export * from "./ProjectProductivityGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports